import React, { useEffect } from "react";
import { BundleInterface } from "../../../../store/mine_craft/bundlesSlice";

import { Button, Form, Input, Switch } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: BundleInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <FileDropzone name='push_cert' label='Push Cert' />

      <Form.Item name='name' label="Name">
        <Input disabled />
      </Form.Item>

      <Form.Item label="Notification" name='notification' valuePropName='checked'>
        <Switch
          checkedChildren='enabled'
          unCheckedChildren='disabled'
        />
      </Form.Item>

      <Form.Item label="Environment" name='prod' valuePropName='checked'>
        <Switch
          checkedChildren='production'
          unCheckedChildren='development'
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
